<!-- src/components/OfferCardModal.vue -->
<template>
  <div v-if="visible" class="modal-overlay" @click.self="closeModal">
    <div v-if="visible" class="modal" :style="modalStyle">
      <div class="modal-content">
        <!-- New filter dropdown -->

        <span class="close-button" @click="closeModal">&times;</span>
        <h2>選擇登記卡片</h2>


   
        <div v-if="offer_cards.length === 0" class="no-offer-cards">
          No offer cards available at the moment.
        </div>
        <div class="offer-cards-container">

          <div class="filter-container">
          <select class="form-select2" v-model="selectedBank">
            <option value="">所有銀行</option>
            <option v-for="bank in uniqueBanks" :key="bank" :value="bank">{{ bank }}</option>
          </select>
        </div>               
          <div v-for="offerCard in filteredOfferCards" :key="offerCard.id" class="offer-card">
            <div class="offer-card-image">
              <img :src="getOfferCardImageURL(offerCard.id)" :alt="`${offerCard.name} Image`" />
            </div>
            <div class="offer-card-details">
              <h3 class="offer-card-name">{{ offerCard.bank + ' | ' + offerCard.name }}</h3>
              <button class="apply-button" @click="attempAddToRegisteredCard(offerCard)">輸入卡號</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFullImageURL } from '@/util/util';

export default {
  name: 'OfferCardModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    offer_cards: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      modalStyle: {
        position: 'absolute',
        top: '0px',
        margin: ' auto',
      },
      selectedBank: '' // New data property
    };
  },
  computed: {
    uniqueBanks() {
      const banks = this.offer_cards.map(card => card.bank);
      return [...new Set(banks)];
    },
    filteredOfferCards() {
      if (!this.selectedBank) {
        return this.offer_cards;
      }
      return this.offer_cards.filter(card => card.bank === this.selectedBank);
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.centerModal();
      }
    }
  },
  methods: {
    getFullImageURL,
    closeModal() {
      this.$emit('close');
    },
    centerModal() {
      console.log('centerModal');
      this.$nextTick(() => {
        const modalContent = this.$el.querySelector('.modal-content');
        const root = document.documentElement; // Reference to the transformed root element

        console.log('centerModal');

        const rect = root.getBoundingClientRect();
        const viewportWidth = rect.width;
        const viewportHeight = rect.height;

        console.log('rect', rect);
        console.log('modalContent', modalContent.offsetWidth, modalContent.offsetHeight);
        console.log('modalContent', modalContent);

        const modalRect = modalContent.getBoundingClientRect();
        const scaledWidth = modalRect.width;
        const scaledHeight = modalRect.height;

        console.log('scaledWidth', scaledWidth, 'scaledHeight', scaledHeight);

        let left = rect.left + (viewportWidth - scaledWidth) / 2;
        let top = rect.top + (viewportHeight - scaledHeight) / 2;

        const scale = viewportWidth / 1464.0;

        console.log('left', left, 'top', top);
        if (viewportWidth > 560) {
          top = -rect.top / scale;
        } else {
          top = -rect.top;
        }
        this.modalStyle.top = `${top}px`;
      });
    },

    getOfferCardImageURL(offerCardId) {
      const cardImageDict = {};
      this.offer_cards.forEach(card => {
        cardImageDict[card.id] = card.card_image;
      });

      const card_image_path = cardImageDict[offerCardId];
      if (!card_image_path) {
        return getFullImageURL('/images/placeholder.png');
      }

      return getFullImageURL(card_image_path);
    },
    attempAddToRegisteredCard(offerCard) {
      this.$emit('add-card', offerCard);
    }
  },
  mounted() {
    console.log('OfferCardModal mounted');
  }

};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  z-index: 1000;
}

.modal-content {
  position: relative;
  margin-top: 100px;
  background-color: white;
  border-radius: 15px;
  width: 640px;
  height: 720px;
  text-align: center;
  padding: 24px 0px;
  z-index: 1001;
  box-sizing: border-box;
}

h2 {
  font-family: Inter;
  font-size: 28px;
  font-weight: 700;
  line-height: 38.08px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--green03);
  margin-top: 0px;
  margin-bottom: 34px;
}

.close-button {
  position: absolute;
  top: 24px;
  right: 32px;
  font-size: 30px;
  cursor: pointer;
  color: black;
}

.offer-cards-container {
  padding: 0px 30px;
  max-height: 590px;
  overflow-y: auto;
}

.offer-card {
  display: flex;
  align-items: center;
  padding: 24px;
  margin-bottom: 20px;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s;
  width: 572px;
  height: 123px;
  box-sizing: border-box;
}

.offer-card:hover {
  transform: translateY(-3px);
}

.offer-card-image {
  width: 120px;
  height: 75px;
  margin-right: 20px;
  border-radius: 4px;
  overflow: hidden;
}

.offer-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.offer-card-details {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
}

.offer-card-name {
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--gray15);
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin-right: 10px;
}

.apply-button {
  padding: 12px 24px;
  border-radius: 99px;
  border: none;
  color: white;
  background-color: var(--green03);
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  transition: background-color 0.3s ease;
}

.apply-button:hover {
  background-color: var(--green02);
}

.offer-cards-container::-webkit-scrollbar {
  width: 8px;
}

.offer-cards-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.offer-cards-container::-webkit-scrollbar-thumb {
  background-color: var(--gray11);
  border-radius: 10px;
  border: 1px solid #f1f1f1;
}

.offer-cards-container::-webkit-scrollbar-thumb:hover {
  background-color: var(--gray11);
}

@media (max-width: 560px) {
  .modal-content {
    width: 343px;
    height: 480px;
    padding: 20px 0px;
  }

  h2 {
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 20px;
  }

  .offer-cards-container {
    padding: 0px 16px;
    max-height: 400px;
  }

  .offer-card {
    padding: 16px;
    width: 303px;
    height: 64px;
  }

  .offer-card-image {
    width: 64px;
    height: 40px;
    margin-right: 10px;
    border-radius: 6px;
  }

  .offer-card-name {
    font-family: Inter;
    font-size: 12px;
    font-weight: 700;
    line-height: 18.48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }

  .apply-button {
    max-width: 820px;
    height: 34px;
    padding: 8px 16px;
    white-space: nowrap;
    font-family: Inter;
    font-size: 12px;
    font-weight: 700;
    line-height: 18.48px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
}

.filter-container {
  margin-bottom: 20px;
  /* padding: 0px 30px; */
  /* //align items to the left  */
  display: flex;
  justify-content: flex-start;


}

.form-select2 {
  width: 200px;
  height: 64px;
  border-radius: 12px;
  border: 1px solid var(--gray11);
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  padding: 16px;
  color: var(--gray15);
}

@media screen and (max-width: 560px) {
  .form-select2 {
    height: 48px;
    width: 150px;
    font-size: 14px;
    padding: 12px;
  }
}
</style>